import React, { Component } from 'react';

class Bookmarklet extends Component {
    render() {
        const bookmarkletUrl = process.env.REACT_APP_BOOKMARKLET_URL || 'http://localhost:3000';
        const bookmarkletHtml = `<a href="javascript:(function(){try{var%20p=window.open('${bookmarkletUrl}/popup/lookup?url='+encodeURIComponent(location.href)+'&title='+encodeURIComponent(document.title),'_blank','height=580,width=540,resizable,scrollbars=yes,status=no');if(!p||p.closed||typeof%20p.closed=='undefined'){alert('NslMail%20Bookmarklet:%20Please%20allow%20popups%20for%20this%20site.%5Cn%5CnTip:%20Hold%20Ctrl%20(or%20Cmd%20on%20Mac)%20while%20clicking%20the%20bookmarklet%20to%20bypass%20popup%20blockers.');}}catch(e){alert('NslMail%20Bookmarklet%20Error:%20This%20site%20prevents%20the%20bookmarklet%20from%20working.%5Cn%5CnError:%20'+e.message+'%5Cn%5CnTry%20holding%20Ctrl/Cmd%20while%20clicking,%20or%20use%20the%20bookmarklet%20from%20a%20different%20site.');}})()"><img alt="NslMail Alias" border="0" src="/images/nslmail_sm.gif?1532648642" /></a>`;

        return <div>
            <h1>NslMail Bookmarklet</h1>
            <br/>
            <h2>What is a bookmarklet and why do I need it?</h2>
            <p>Bookmarklets are links you add to your browser's Bookmarks Toolbar. It is an easy way to create and retrieve your NslMail aliases from any site you may be browsing.  You can read more about them on <a href="http://en.wikipedia.org/wiki/Bookmarklet" rel="noopener noreferrer" target="_blank">Wikipedia</a>.</p>

            <h2>How do I install my NslMail bookmarklet?</h2>

            <p>It's easy, all you have to do is drag
            <span dangerouslySetInnerHTML={{__html: bookmarkletHtml}}></span>
            to your bookmarks toolbar.  If you do not have your toolbar enabled, you can right click the image and bookmark it instead.
            </p>
            <p>
            <b>Note:</b> <i>This bookmarklet contains javascript to help it integrate better with your browsing experience.  Your browser may
            warn you when bookmarking it.  You can safely accept the warning; all that the javascript does is pass the URL and page title of the
            page you are viewing to NslMail to assist you in creating your aliases.  Nothing is ever stored on our systems without you pressing
            the save button.</i>
            </p>

            <h2>It's installed, how do I use it?</h2>
            <p>
            When you encounter a form asking for your email address, simply click the NslMail Alias button in your toolbar, or select the link from
            your bookmarks menu.  A window will popup pre-populated with the sites information.  You may want to adjust the site name to something
            more meaningful if it's not already.  The Site URL is the important part; you should generally leave it at its default so NslMail can
            properly filter your email.  If the URL contains personal information you may want to remove it before saving.
            </p>
            <p>
            If you are returning to a site with which you already have an alias, pressing the NslMail Alias button will popup showing you
            any aliases you have previously created.  You can simply copy and paste them.
            </p>
            <p>
            <b>Note:</b> <i>Some popup blockers may prevent the NslMail button from working properly.  If this is the case you can try and hold down
            the CTRL key when clicking on the button.  This will generally allow the window to popup.  If that does not work, NslMail may not be
            compatible with your browser.  You can contact support for further assisstance.</i>
            </p>

            <h2>Troubleshooting</h2>

            <h4>Issue: Popup is blocked</h4>
            <ul>
                <li>Hold Ctrl (Windows/Linux) or Cmd (Mac) while clicking the bookmarklet</li>
                <li>Check your browser's popup blocker settings and allow popups from the site you're on</li>
                <li>Look for a popup blocked notification in your browser's address bar</li>
            </ul>

            <h4>Issue: "Storage Access Blocked" error</h4>
            <ul>
                <li><b>Safari:</b> Go to Preferences → Privacy → Uncheck "Prevent cross-site tracking"</li>
                <li><b>Firefox:</b> Click the shield icon in the address bar → Turn off Enhanced Tracking Protection for this site</li>
                <li><b>Chrome:</b> Go to Settings → Privacy and security → Cookies → Allow third-party cookies</li>
                <li><b>Alternative:</b> Instead of using the bookmarklet, open <a href="/aliases" target="_blank">NslMail in a new tab</a> and use it directly</li>
            </ul>

            <h4>Sites Known to Block Bookmarklets</h4>
            <p>The following types of sites commonly have strict security policies that prevent bookmarklets:</p>
            <ul>
                <li>Banking and financial websites</li>
                <li>Government websites</li>
                <li>Social media platforms (Facebook, Twitter, LinkedIn)</li>
                <li>Corporate intranets and VPNs</li>
            </ul>
            <p>For these sites, we recommend copying the site URL manually and creating your alias at <a href="/new-alias" target="_blank">nslmail.com/new-alias</a>.</p>
        </div>
    }
}

export default Bookmarklet;